@if(!modelId){

<ng-container>
  <div class="flex margin-bottom-small">
    <div class="flex-1 flex center">
      <h4 class="margin-left-small">Styles</h4>
    </div>
  </div>

  <mat-chip-set>
    @for (element of filtersList; track element) {
    @let label = getLabel(element.id);
    <mat-chip-row (click)="openDialogFilter(element.id)" class="filter-chip" [title]="getFullTitleFilter(element.id)">
      {{element.label + (label ? label: '')}}
      @if(label){
        <mat-icon matChipRemove (click)="clearFilter($event, element.id)">cancel</mat-icon>
      }
    </mat-chip-row>
    }
  </mat-chip-set>

  <bt-loader [loaderId]="loaderId">
    @if(database.data){
    <bt-table [dataSource]="database.data" [displayedColumns]="columns" [pagination]="true"
      [pageNumber]="database.pageNumber" [pageSize]="database.pageSize" [totalNumber]="database.total"
      (clickPage)="getCompanyStyles($event)" />
    }
  </bt-loader>

  <ng-template #menuColumn let-row="row">
    <bt-menu [show]="row.showMenu" (hidden)="row.showMenu = false" (showed)="row.showMenu = true">
      <div class="menu-item" (click)="onStyleInfo(row)">
        <i class="fa fa-info"></i>Style info
      </div>
      <div class="menu-item" [ngClass]="{'disabled': !row.sketchImgPath}" (click)="onStyleSketch(row)">
        <i class="fa fa-eye"></i>Style sketch
      </div>
      <div class="menu-item" [ngClass]="{'disabled': !row.ordersInfo?.length}"
        (click)="onStyleSidebarInfo(row, 'Style orders')">
        <i class="fa fa-list"></i>Style orders
      </div>
      <div class="menu-item" [ngClass]="{'disabled': !row.warehouses?.length}"
        (click)="onStyleSidebarInfo(row, 'Style warehouses')">
        <i class="fa fa-list"></i>Style warehouses
      </div>
      <div class="menu-item warning" (click)="onReshootStyle(row)">
        <i class="fa fa-trash"></i>Reshoot this style
      </div>
    </bt-menu>
  </ng-template>

  <ng-template #warehouseColumn let-row="row">
    <span>{{ row.warehouses?.length || 0 }} warehouses related to style</span>
  </ng-template>

  <ng-template #styleOrderColumn let-row="row">
    <span>{{ row.ordersInfo?.length || 0 }} orders related to style</span>
  </ng-template>

  @if(currentSidebar === sidebarTypeEnum.customSidebar && customSidebarTitle === 'Style orders'){
  <bt-sidebar [sidebarTitle]="customSidebarTitle" (exit)="onExitSidebar()">
    @if(database.tmp){
    <div class="full-height flex">
      <div class="flex-0 margin-top-large margin-bottom-large padding-left-x-small padding-right-x-small">
        This is the list of orders related to style <b>{{database.tmp.fullName}}</b>.
      </div>
      <div class="flex-1 overflow margin-bottom padding-left-x-small padding-right-x-small">
        <table>
          <tr>
            @for(col of ordersGridColumns; track col) {
            <th [ngStyle]="{'width': col.width ? col.width + 'px' : null }">
              {{col.title}}</th>
            }
          </tr>
          @for(item of database.tmp.ordersInfo; track item) {
          <tr>
            @for(col of ordersGridColumns; track col) {
            <td>
              @if(col.type === gridColumnTypeEnum.default){
              <ng-container>
                {{item[col.field] || ' - '}}
              </ng-container>
              }
              @if(col.type === gridColumnTypeEnum.icon){
              <ng-container>
                <div class="pointer flex center justify-center" (click)="onOrderInfo(item)">
                  <i class="fa fa-info"></i>
                </div>
              </ng-container>
              }
            </td>
            }
          </tr>
          }
        </table>
      </div>
      <div class="flex-0">
        <button class="full-width" (click)="onOrderList()">
          <i class="fa fa-external-link"></i>
          Go to order list
        </button>
      </div>
    </div>
    }
  </bt-sidebar>
  }

  @if(currentSidebar === sidebarTypeEnum.customSidebar && customSidebarTitle === 'Style warehouses'){
  <bt-sidebar [sidebarTitle]="customSidebarTitle" (exit)="onExitSidebar()">
    @if(database.tmp){
    <div class="full-height flex">
      <div class="flex-0 margin-top-large margin-bottom-large padding-left-x-small padding-right-x-small">
        This is the list of warehouses related to style <b>{{database.tmp.fullName}}</b>.
      </div>
      <div class="flex-1 overflow margin-bottom padding-left-x-small padding-right-x-small">
        <table>
          <tr>
            @for(col of warehouseGridColumns; track col) {
            <th [ngStyle]="{'width': col.width ? col.width + 'px' : null }">
              {{col.title}}</th>
            }
          </tr>
          @for(item of database.tmp.warehouses; track item) {
          <tr>
            @for(col of warehouseGridColumns; track col) {
            <td>
              @if(col.type === gridColumnTypeEnum.default){
              <ng-container>
                {{item[col.field] || ' - '}}
              </ng-container>
              }
            </td>
            }
          </tr>
          }
        </table>
      </div>
      <div class="flex-0">
        <button class="full-width" (click)="onOrderList()">
          <i class="fa fa-external-link"></i>
          Go to order list
        </button>
      </div>
    </div>
    }
  </bt-sidebar>
  }

  @if(currentSidebar === sidebarTypeEnum.deleteAction){
  <bt-sidebar sidebarTitle="Reshoot entire style" (exit)="onExitSidebar()">
    <bt-loader [loaderId]="sidebarLoaderId">
      @if(database.tmp){
      <div class="flex vertical full-height">
        <div class="flex-1 flex center justify-center">
          <div>
            Are you sure you want to <b>reshoot</b> entire style {{database.tmp.fullName}}?
            <br><br>
            All style shots will be deleted.
          </div>
        </div>
        <div class="flex-0">
          <button class="full-width warning" (click)="reshootStyle()">
            <i class="fa fa-trash"></i>
            Reshoot entire style
          </button>
        </div>
      </div>
      }
    </bt-loader>
  </bt-sidebar>
  }

</ng-container>
}

@if(modelId){
<bt-item-info [modelId]="modelId" (exit)="onExitFromInfo()"></bt-item-info>
}